import { createAsyncThunk, Dispatch } from "@reduxjs/toolkit";
import pipelinesService from "@/services/pipelines.service";
import dealsService from "@/services/deals.service";
import { pipelinesLoaded, startLoading, setCurrentPipeline, pipelineAdded, pipelineUpdated, pipelineDeleted, dealStatusCreated, dealStatusUpdated, dealStatusDeleted } from "./pipelines.slice";
import { RootState } from "@/store";
import { TDealStatus } from "@/models/deals.model";

export const getAllPipelines = () => async (dispatch: Dispatch, getState: () => RootState) => {
    const { initialized } = getState().pipelines;
    if (initialized) return;

    dispatch(startLoading());
    const response = await pipelinesService.getAll();

    dispatch(pipelinesLoaded(response));
};

export const changeCurrentPipeline = (pipelineId: number) => async (dispatch: Dispatch) => {
    dispatch(setCurrentPipeline(pipelineId));
};

export const createDealStatus = createAsyncThunk(
    "pipelines/createDealStatus",
    async (payload: {
        pipelineId: number;
        name: string;
        color: string;
        isClosedStatus?: boolean;
    }, { dispatch }) => {
        const response = await dealsService.saveDealStatus(payload);
        dispatch(dealStatusCreated({ pipelineId: payload.pipelineId, status: response }));
        return response;
    }
);

export const updateDealStatus = createAsyncThunk(
    "pipelines/updateDealStatus",
    async (payload: {
        pipelineId: number;
        statusId: number;
        name: string;
        color: string;
        isClosedStatus: boolean;
    }, { dispatch }) => {
        const { statusId, name, color, isClosedStatus, pipelineId } = payload;
        const response = await dealsService.updateDealStatus({ id: statusId, name, color, isClosedStatus } as TDealStatus);
        dispatch(dealStatusUpdated({ pipelineId, status: response }));
        return response;
    }
);

export const deleteDealStatus = createAsyncThunk(
    "pipelines/deleteDealStatus",
    async (payload: {
        pipelineId: number;
        statusId: number;
        newStatusId?: number;
    }, { dispatch }) => {
        await dealsService.deleteDealStatus(payload.statusId, payload.newStatusId);
        dispatch(dealStatusDeleted({ pipelineId: payload.pipelineId, statusId: payload.statusId }));
    }
);
export const createPipeline = (pipelineName: string) => async (dispatch: Dispatch) => {
    const newPipeline = await pipelinesService.save(pipelineName);
    dispatch(pipelineAdded(newPipeline));
    return newPipeline;
};

export const updatePipeline = (pipelineId: number, pipelineName: string) => async (dispatch: Dispatch) => {
    const updatedPipeline = await pipelinesService.updateById(pipelineId, pipelineName);
    dispatch(pipelineUpdated(updatedPipeline));
    return updatedPipeline;
};

export const deletePipeline = (pipelineId: number) => async (dispatch: Dispatch) => {
    await pipelinesService.deleteById(pipelineId);
    dispatch(pipelineDeleted(pipelineId));
};
